import type { NavItem } from '@/components/UiNavigation/UiNavigation.types'

export const INVESTOR_SUB_MENU_ITEMS: NavItem[] = [
  {
    label: 'investor.submenu.reports.label',
    link: 'investor.submenu.reports.link',
  },
  {
    label: 'investor.submenu.resultsCenter.label',
    link: 'investor.submenu.resultsCenter.link',
    children: [
      {
        label: 'investor.submenu.resultsCenter.children.presentations.label',
        link: 'investor.submenu.resultsCenter.children.presentations.link',
        external: false,
      },
      {
        label: 'investor.submenu.resultsCenter.children.financialData.label',
        link: 'investor.submenu.resultsCenter.children.financialData.link',
        external: false,
      },
      {
        label: 'investor.submenu.resultsCenter.children.investorChats.label',
        link: 'investor.submenu.resultsCenter.children.investorChats.link',
        external: false,
      },
    ],
  },
  {
    label: 'investor.submenu.shares.label',
    link: 'investor.submenu.shares.link',
    children: [
      {
        label: 'investor.submenu.shares.children.shareholders.label',
        link: 'investor.submenu.shares.children.shareholders.link',
        external: false,
      },
      {
        label: 'investor.submenu.shares.children.stockQuotes.label',
        link: 'investor.submenu.shares.children.stockQuotes.link',
        external: false,
      },
      {
        label: 'investor.submenu.shares.children.recommendations.label',
        link: 'investor.submenu.shares.children.recommendations.link',
        external: false,
      },
      {
        label: 'investor.submenu.shares.children.dividendPolicy.label',
        link: 'investor.submenu.shares.children.dividendPolicy.link',
        external: false,
      },
      {
        label: 'investor.submenu.shares.children.publicOffering.label',
        link: 'investor.submenu.shares.children.publicOffering.link',
      },
    ],
  },
  {
    label: 'investor.submenu.corporateGovernance.label',
    link: 'investor.submenu.corporateGovernance.link',
    children: [
      {
        label: 'investor.submenu.corporateGovernance.children.managementBoard.label',
        link: 'investor.submenu.corporateGovernance.children.managementBoard.link',
        external: false,
      },
      {
        label: 'investor.submenu.corporateGovernance.children.supervisoryBoard.label',
        link: 'investor.submenu.corporateGovernance.children.supervisoryBoard.link',
      },
      {
        label: 'investor.submenu.corporateGovernance.children.generalMeeting.label',
        link: 'investor.submenu.corporateGovernance.children.generalMeeting.link',
      },
      {
        label: 'investor.submenu.corporateGovernance.children.statutoryAuditor.label',
        link: 'investor.submenu.corporateGovernance.children.statutoryAuditor.link',
      },
      {
        label: 'investor.submenu.corporateGovernance.children.bestPractices.label',
        link: 'investor.submenu.corporateGovernance.children.bestPractices.link',
        external: false,
      },
      {
        label: 'investor.submenu.corporateGovernance.children.corporateDocuments.label',
        link: 'investor.submenu.corporateGovernance.children.corporateDocuments.link',
        external: false,
      },
      {
        label: 'investor.submenu.corporateGovernance.children.genderBalance.label',
        link: 'investor.submenu.corporateGovernance.children.genderBalance.link',
        external: false,
      },
      {
        label: 'investor.submenu.corporateGovernance.children.incentivePrograms.label',
        link: 'investor.submenu.corporateGovernance.children.incentivePrograms.link',
      },
      {
        label: 'investor.submenu.corporateGovernance.children.significantTransactions.label',
        link: 'investor.submenu.corporateGovernance.children.significantTransactions.link',
      },
      {
        label: 'investor.submenu.corporateGovernance.children.merger.label',
        link: 'investor.submenu.corporateGovernance.children.merger.link',
      },
      {
        label: 'investor.submenu.corporateGovernance.children.usefulLinks.label',
        link: 'investor.submenu.corporateGovernance.children.usefulLinks.link',
        external: false,
      },
      {
        label: 'investor.submenu.corporateGovernance.children.listOfCompaniesInTheCapitalGroup.label',
        link: 'investor.submenu.corporateGovernance.children.listOfCompaniesInTheCapitalGroup.link',
        external: false,
      },
    ],
  },
  {
    label: 'investor.submenu.bonds.label',
    link: 'investor.submenu.bonds.link',
  },
  {
    label: 'investor.submenu.esg.label',
    link: 'investor.submenu.esg.link',
    external: false,
  },
  {
    label: 'investor.submenu.calendar.label',
    link: 'investor.submenu.calendar.link',
    external: false,
  },
  {
    label: 'investor.submenu.faq.label',
    link: 'investor.submenu.faq.link',
    external: false,
  },
  {
    label: 'investor.submenu.contact.label',
    link: 'investor.submenu.contact.link',
    external: false,
  },
]
